var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ClickAwayListener, iconButtonClasses, Paper, Popper } from "@mui/material";
import { useEffect } from "react";
import { combineSxProps, createDraggableTransition } from "../../Utils";
import { truffleModalTitleDragHandleClassName } from "../TruffleModalTitle";
export const TrufflePopper = (_a) => {
    var { variant = "standard", children, onClose, PaperProps } = _a, popperProps = __rest(_a, ["variant", "children", "onClose", "PaperProps"]);
    useEffect(() => {
        if (onClose) {
            const handleKeyDown = (e) => {
                if (e.key === "Escape") {
                    onClose();
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return () => {
                window.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [onClose]);
    const _b = PaperProps || {}, { sx } = _b, paperProps = __rest(_b, ["sx"]);
    return (_jsx(Popper, Object.assign({ transition: true, placement: "bottom-start" }, popperProps, { children: ({ TransitionProps }) => (_jsx(ClickAwayListener, { onClickAway: onClose !== null && onClose !== void 0 ? onClose : noOp, children: _jsx(DraggableTransition, Object.assign({}, TransitionProps, { children: _jsx(Paper, Object.assign({ elevation: 8, sx: combineSxProps(PAPER_SX_BY_VARIANT[variant], sx) }, paperProps, { children: children })) })) })) })));
};
const PAPER_SX_BY_VARIANT = {
    standard: {
        paddingBlockStart: "8px",
        paddingBlockEnd: "16px",
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        minWidth: "260px"
    },
    pill: {
        paddingBlockStart: "4px",
        paddingBlockEnd: "4px",
        paddingInlineStart: "4px",
        paddingInlineEnd: "4px",
        borderRadius: "999px"
    }
};
const DraggableTransition = createDraggableTransition({
    draggableProps: {
        handle: `.${truffleModalTitleDragHandleClassName}`,
        cancel: `.${iconButtonClasses.root}`
    }
});
function noOp() { }
//# sourceMappingURL=TrufflePopper.js.map